import React, { useEffect } from "react";
import Navbar from "../component/Header.js/Navbar/Navbar";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../component/Footer/Footer";
import FeatureProductBox from "../component/UI/FeatureProductBox";
import { useSelector } from "react-redux";

const MainBox = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 60vh;
  padding: 4rem 1rem;
  display: flex;
  flex-direction: column;

  & > span {
    text-transform: capitalize;
    color: #777;
    font-size: 1.6rem;
    margin-bottom: 1rem;
  }

  @media only screen and (max-width: 1099px) {
    width: 95%;
    padding: 2rem 1rem;
  }
`;

const HeadingAndCount = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4rem;
  margin-bottom: 2rem;

  h1 {
    font-size: 5.7rem;
    font-weight: 400;
    margin: 0;
    color: black;
  }

  p {
    color: #777;
    font-size: 1.6rem;
    margin-top: 1rem;
  }

  @media only screen and (max-width: 1099px) {
    padding: 0 1rem;
    h1 {
      font-size: 4rem;
    }
    p {
      font-size: 1.3rem;
    }
  }
`;

const ProductsDiv = styled.div`
  margin: 3rem 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2.5rem 2rem;

  a {
    text-decoration: none;
    color: inherit;
    display: block;
    width: 100%;
  }

  @media only screen and (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem 1.5rem;
  }

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem 1rem;
  }

  @media only screen and (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.2rem 0.8rem;
  }
`;

const EmptyState = styled.div`
  width: 100%;
  height: 40vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #777;
  gap: 2rem;

  h2 {
    font-size: 2.4rem;
    font-weight: 500;
    color: #555;
  }

  p {
    font-size: 1.6rem;
    color: #999;
  }
`;

const Button = styled(Link)`
  text-decoration: none;
  background-color: black;
  color: white;
  padding: 1.2rem 3rem;
  font-size: 1.6rem;
  font-weight: 500;
  border-radius: 3rem;
  transition: all 0.3s ease;
  margin-top: 1rem;

  &:hover {
    background-color: #333;
    transform: translateY(-2px);
  }
`;

const Wishlist = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  const wishlistItems = useSelector((state) => state.wishlistItems) || [];

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  return (
    <>
      <Navbar />
      <MainBox>
        <span>Home / Wishlist</span>
        <HeadingAndCount>
          <h1>My Wishlist</h1>
          {isLoggedIn && (
            <p>
              {wishlistItems.length === 0
                ? "You don't have any items in your wishlist yet."
                : `You have ${wishlistItems.length} ${
                    wishlistItems.length === 1 ? "item" : "items"
                  } in your wishlist.`}
            </p>
          )}
        </HeadingAndCount>

        {!isLoggedIn ? (
          <EmptyState>
            <h2>Please login to view your wishlist</h2>
            <p>Add items to your wishlist to save them for later.</p>
            <Button to="/login">Login / Sign Up</Button>
          </EmptyState>
        ) : wishlistItems.length === 0 ? (
          <EmptyState>
            <h2>Your wishlist is empty</h2>
            <p>Explore our products and find something you love!</p>
            <Button to="/product-category/all-products">Start Shopping</Button>
          </EmptyState>
        ) : (
          <ProductsDiv>
            {wishlistItems.map((item) => {
              const colors = item.color ? item.color.split(",") : ["Default"];
              const image = item.featuredImage || (item.images ? item.images.split(" ")[0] : item.img);
              return (
                <Link
                  to={`/product/${item.category}/${item.slug}/${item.id}`}
                  key={item.id}
                  state={{ productId: `${item.id}` }}
                >
                  <FeatureProductBox
                    data={{ ...item, colors: colors, img: image }}
                  />
                </Link>
              );
            })}
          </ProductsDiv>
        )}
      </MainBox>
      <Footer />
    </>
  );
};

export default Wishlist;
